import template from './serverSideLoginScreen.html';
import controller from './serverSideLoginScreen.controller';
import './serverSideLoginScreen.scss'

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    onLogin: '&',
  },
};

export default component;
